/**
 * Settings Page
 *
 * Refactored to use modular sub-components for improved maintainability.
 * All state management is handled by the useSettings hook.
 */

import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { useIsSupplier } from '../hooks/usePortalMode';
import {
  useSettings,
  ProfileTab,
  CompanyTab,
  NotificationsTab,
  SecurityTab,
} from './settings-page';

export default function Settings() {
  const isSupplier = useIsSupplier();
  const {
    // Profile
    profileForm,
    loadingProfile,
    savingProfile,
    handleProfileChange,
    handleSaveProfile,

    // Notifications
    notifPrefs,
    loadingNotifPrefs,
    savingNotifPrefs,
    handleNotifPrefChange,
  } = useSettings();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold tracking-tight">My Account</h1>
        <p className="text-muted-foreground mt-2">
          Manage your personal preferences and account settings.
        </p>
      </div>

      {/* Settings Tabs */}
      <Tabs defaultValue="profile" className="space-y-4">
        <TabsList>
          <TabsTrigger value="profile">Profile</TabsTrigger>
          {isSupplier && <TabsTrigger value="company">Company</TabsTrigger>}
          <TabsTrigger value="notifications">Notifications</TabsTrigger>
          <TabsTrigger value="security">Security</TabsTrigger>
        </TabsList>

        {/* Profile Tab — in customer mode, includes company info inline */}
        <TabsContent value="profile">
          <ProfileTab
            profileForm={profileForm}
            loadingProfile={loadingProfile}
            savingProfile={savingProfile}
            onProfileChange={handleProfileChange}
            onSaveProfile={handleSaveProfile}
          />
          {!isSupplier && (
            <div className="mt-6">
              <CompanyTab />
            </div>
          )}
        </TabsContent>

        {/* Company Tab — supplier only (in customer mode it's merged into Profile) */}
        {isSupplier && (
          <TabsContent value="company" className="space-y-4">
            <CompanyTab />
          </TabsContent>
        )}

        {/* Notifications Tab */}
        <TabsContent value="notifications" className="space-y-4">
          <NotificationsTab
            notifPrefs={notifPrefs}
            loadingNotifPrefs={loadingNotifPrefs}
            savingNotifPrefs={savingNotifPrefs}
            onPrefChange={handleNotifPrefChange}
          />
        </TabsContent>

        {/* Security Tab */}
        <TabsContent value="security" className="space-y-4">
          <SecurityTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
